import { getItemHighlight, getSecondaryHighlight } from "./utils";

export function getPhonePlanTemplate(item, html) {
  return html` <div class="aa-ItemWrapper">
    <div class="aa-ItemContent">
      <div class="aa-ItemIcon aa-ItemIcon--alignTop">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="sim-card"
          class="svg-inline--fa fa-sim-card "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          height="24"
          width="24"
        >
          <path
            fill="currentColor"
            d="M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
          ></path>
        </svg>
      </div>
      <div class="aa-ItemContentBody">
        <div class="aa-ItemContentTitle">
          ${getItemHighlight(html, item, "phone_plan.phone_plan_tariff_name")}
          Provider:${getItemHighlight(
            html,
            item,
            "phone_plan.phone_plan_tariff_provider"
          )}
        </div>
        <div class="aa-ItemContentDescription">
          ${getSecondaryHighlight(html, item, "phone_plan.indentifier")} Simcard
          Number: ${item.document["phone_plan.simcard_number"]}
          <span class="orgid label label-default"
            >Org ID: ${item.document["phone_plan.organisation_id"]}</span
          >
          <span class="text-danger ml-1">
            (${item.document["phone_plan.organisation_name"]})</span
          >
        </div>
      </div>
    </div>
  </div>`;
}
